module.exports = __webpack_public_path__ + "img/banner1.7f02fd7e.png";